import { chakra } from "@chakra-ui/react";
import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import {
  FieldWrapper,
  FieldWrapperPassThroughProps,
} from "components/Forms/FieldWrapper";

type LoginFieldProps = FieldWrapperPassThroughProps & {
  type?: "text" | "email" | "password";
  registration: Partial<UseFormRegisterReturn>;
  watch?: string;
  placeholder?: string;
  passwordChecker?: boolean;
};

export const LoginField: {
  (props: LoginFieldProps): React.ReactElement;
} = (props) => {
  const { type = "text", label, placeholder, registration, error } = props;

  return (
    <>
      <FieldWrapper label={label} error={error}>
        <chakra.input
          type={type}
          w="100%"
          appearance="none"
          border="2px"
          borderColor="#FFD9D9"
          shadow="inner"
          py="10px"
          pl="30px"
          boxSizing="border-box"
          borderRadius="3xl"
          color="brand.primary"
          outline={0}
          _placeholder={{
            color: "grey.1",
            fontSize: "14px",
            lineHeight: "19px",
          }}
          placeholder={placeholder}
          {...registration}
        />
      </FieldWrapper>
    </>
  );
};
